export default class DiscountProgram {
    Id: number = 0;
    Name: string = '';
    Description: string = '';
    RuleLink: string = '';
    Conditions: Array<any> = [];
}